import { ENRICHMENT_CATEGORY_TYPE_VOTE } from 'common-data-handling';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import resolvePath from '../../../misc/resolvePath';
import WaitWhileBusy from '../../WaitWhileBusy';
import Link from '../../elements/Link';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import Screen from '../Screen';
import enrichmentsConnect from './common/connectEnrichments';

class EnrichmentConclusionScreen extends React.Component {
    componentDidMount() {
        const {event, cat, category} = this.props;
        if (![2, 3].includes(parseInt(cat)) && (!category || !category.confirmation_text)) {
            console.log("conclusion screen isn't used for this category", cat);
            if (this.props.onContinueClicked) {
                this.props.onContinueClicked();
            } else {
                app.history.push(['/events', event.id].join('/'));
            }
        }
    }
    render() {
        let {i18n, hasResults, cat, category} = this.props,
            header = (
                <TopBarEvent event={this.props.event} returnURL={this.props.returnURL}>
                    {this.props.headerTitle}
                </TopBarEvent>
            );

        return (
            <Screen header={header}>
                <div
                    className="content full-center text-center"
                    style={{
                        fontSize: '200%',
                    }}>
                    <p>
                        <b>
                            <u>{i18n['label.title.finished.vote']}</u>
                        </b>
                    </p>
                    <br />
                    {this.props.category?.confirmation_text ? (
                        <p>{this.props.category?.confirmation_text}</p>
                    ) : cat == ENRICHMENT_CATEGORY_TYPE_VOTE ? (
                        <p>{hasResults ? i18n['label.text.finished.vote'].replace('\\n', '\n') : i18n['label.text.finished.vote.hidden-results']}</p>
                    ) : null}
                    <br />
                    <Link
                        type="button"
                        className="btn btn-md"
                        href={this.props.nextPage ? this.props.nextPage : ['/events', this.props.event.id].join('/')}
                        onClick={this.props.onContinueClicked}
                        style={this.props.event._local.styles.button}>
                        {hasResults ? i18n['button.view.results'] : i18n['label.continue']}
                    </Link>
                </div>
            </Screen>
        );
    }
}
const EventEnrichmentsRequiredConnected = connect((state, props) => {
    const {cat} = props;
    let enrichment = enrichmentsConnect(state, props);
    const event = state.events[props.eventId].event,
        hasResults = !!enrichment.questions.find(item => [2, 3].includes(item.question.show_results && item.results)),
        category = _(state.events[props.eventId].event.enrichment_categories).find({category: parseInt(cat)});

    return {
        event,
        i18n: state.i18n.translations,
        nextPage: hasResults ? resolvePath(app.history.location.pathname, '..', 'results') : null,
        headerTitle: category ? category.label : null,
        category,
        returnURL: ['/events', event.id].join('/'),
        cat,
        hasResults,
    };
})(EnrichmentConclusionScreen);

export default props => {
    const params = useParams();
    return (
        <WaitWhileBusy>
            <EventEnrichmentsRequiredConnected {...params} {...props} />
        </WaitWhileBusy>
    );
};
